// ElectionMode/Result.js
import React, { useContext, useState } from "react";
import "../../styles/Report.css";
import { ToastContainer } from "react-toastify";
import { MdUpload } from "react-icons/md";
import SurveyContext from "../../context/surveyContext";
import PageHeading from "../PageHeading";

import ElectionModeUploadForm from "./ElectionModeUploadForm";
import ElectionModeList from "./ElectionModeList";

const Result = () => {
  const surveyContext = useContext(SurveyContext);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleOpenModal = () => {
    surveyContext.updateOpenModal(true);
  };

  const handleCloseModal = () => {
    surveyContext.updateOpenModal(false);
  };

  const handleElectionModeCreated = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="gms-page-section report-tabs">
      <ToastContainer />

      <div className="gms-wrapper">
        <PageHeading
          pageTitle="Election Mode"
          icon={<MdUpload />}
          pageModalTitle="Upload Election Data"
          pageModalOpen={handleOpenModal}
        />

        <ElectionModeUploadForm
          isOpen={surveyContext.isOpenModal}
          onClose={handleCloseModal}
          onCreated={handleElectionModeCreated}
        />

        <ElectionModeList refreshKey={refreshKey} />
      </div>
    </div>
  );
};

export default Result;
